import React from "react";
import Context from "../../../../context";
import {
  CustomView,
  CustomModal,
  CustomButton2,
  UserInformation,
} from "../../../../components";

import "./index.sass";
import { useTranslation } from "react-i18next";

const Approve = () => {
  const {
    showModal,
    setShowModal,
    isLoading,
    selectedSchool,
    approveFunction,
  } = React.useContext(Context.SchoolScreen);

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="school-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal("NONE")}
        open={showModal === "APPROVE"}
      >
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <UserInformation
                name={selectedSchool?.name}
                avatar={selectedSchool?.avatar}
                isBlock={!selectedSchool?.approved}
                phoneNumber={selectedSchool?.telephone}
              />
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => setShowModal("NONE")}
                title={t("cancel")}
                type="danger"
              />
            </CustomView.Column>
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => approveFunction(selectedSchool?._id)}
                title={t("approve")}
              />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default Approve;
